import React from 'react'

export default function FormElements({ color }) {
  return (
    <svg width="30" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2817_1239)">
        <path d="M28 7.5H3C2.66858 7.50033 2.35083 7.63213 2.11648 7.86648C1.88213 8.10083 1.75033 8.41858 1.75 8.75V12.5C1.75033 12.8314 1.88213 13.1492 2.11648 13.3835C2.35083 13.6179 2.66858 13.7497 3 13.75H28C28.3314 13.7497 28.6492 13.6179 28.8835 13.3835C29.1179 13.1492 29.2497 12.8314 29.25 12.5V8.75C29.2497 8.41858 29.1179 8.10083 28.8835 7.86648C28.6492 7.63213 28.3314 7.50033 28 7.5ZM28 12.5H3V8.75H28V12.5ZM28 21.25H3C2.66858 21.2503 2.35083 21.3821 2.11648 21.6165C1.88213 21.8508 1.75033 22.1686 1.75 22.5V26.25C1.75033 26.5814 1.88213 26.8992 2.11648 27.1335C2.35083 27.3679 2.66858 27.4997 3 27.5H28C28.3314 27.4997 28.6492 27.3679 28.8835 27.1335C29.1179 26.8992 29.2497 26.5814 29.25 26.25V22.5C29.2497 22.1686 29.1179 21.8508 28.8835 21.6165C28.6492 21.3821 28.3314 21.2503 28 21.25ZM28 26.25H3V22.5H28V26.25ZM13 17.5V18.75H3V17.5H13ZM3 3.75H13V5H3V3.75Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2817_1239">
          <rect width="30" height="30" fill={color} transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
